<!-- Filtros de usuarios -->
<div class="users-filter-container">
    <div class="tabs-filter">
        <button class="tab-filter" [class.active]="activeTab === 'todos'" (click)="changeTab('todos')">
            Todos ({{ assignedUsers.length }})
        </button>
        <button class="tab-filter" [class.active]="activeTab === 'nuevos'" (click)="changeTab('nuevos')">
            Nuevos
        </button>
    </div>

    <div class="search-filter">
        <div class="search-input-container">
            <input type="text" placeholder="Buscar usuario" [(ngModel)]="searchQuery" (input)="loadAssignedUsers()"
                class="search-input" />
            <mat-icon class="search-icon">search</mat-icon>
        </div>

        <div class="sort-dropdown">
            <select [(ngModel)]="sortOrder" (change)="filterUsers()">
                <option value="fecha-ingreso">Fecha de ingreso</option>
                <option value="nombre">Nombre</option>
                <!-- <option value="ultima-actividad">Última actividad</option> -->
            </select>
            <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
        </div>
    </div>
</div>

<!-- Tabla de usuarios -->
<div class="users-table">
    <div class="table-header">
        <div class="header-cell">Nombre y Apellido</div>
        <!-- <div class="header-cell">Plan</div> -->
        <div class="header-cell">Etapa</div>
        <div class="header-cell">Estado</div>
        <!-- <div class="header-cell">Última actividad</div> -->
        <div class="header-cell">Horas utilizadas</div>
        <div class="header-cell"></div>
    </div>

    <div class="table-body">
        <div class="table-row" *ngFor="let user of filteredUsers">
            <div class="table-cell name-cell">{{ user.name }}</div>
            <!-- <div class="table-cell plan-cell">
            <span class="plan-badge" [ngClass]="'plan-' + user.plan.toLowerCase()">{{ user.plan }}</span>
          </div> -->
            <div class="table-cell stage-cell">Planificación</div>
            <div class="table-cell status-cell">
                <span class="status-indicator" [ngClass]="{'active': user.status.name === 'Activo'}"></span>
                {{ user.status.name }}
            </div>
            <!-- <div class="table-cell activity-dropdown">
                <select aria-label="Account Type" name="accountType">
                    <option *ngFor="let x of lastActivity" value="{{x.date}}">
                        {{x.activity}}
                    </option>
                </select>
                <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
            </div> -->
            <div class="table-cell activity-cell">{{user.type.subscription.coachHoursUsed || 0}}h/{{user.type.subscription.coachHoursTotal || 0}}h</div>
            <div class="table-cell actions-cell">
                <button class="action-button" (click)="viewUser(user)">
                    <mat-icon>arrow_circle_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>